import {
  toWSDateString,
  WSTableCell,
  WSTableColumn,
  WSTableColumnSortDirection
} from "@wingspanhq/fe-component-library";
import { IInvoice } from "@wingspanhq/payments/dist/interfaces";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { IPayerRow } from "../../../../services/search";
import { getPayerNames } from "../../../Payers/utils/getPayerNames";
import { getWorkLogPayeeStatusCellProps } from "../../utils/getWorkLogPayeeStatusCellProps";
import { TableItemData } from "./TableWorkLogsPayeeView";

type ColumnsConfig = {
  payersMap: Map<string, IPayerRow>;
  invoicesMap?: Map<string, IInvoice>;
  onSortByUpdatedAt: (newDirection: WSTableColumnSortDirection) => void;
  updatedAtDirection?: WSTableColumnSortDirection;
};

export const getColumns = ({
  payersMap,
  invoicesMap,
  onSortByUpdatedAt,
  updatedAtDirection
}: ColumnsConfig): WSTableColumn<TableItemData>[] => [
  {
    config: {
      header: {
        text: "Client"
      }
    },
    renderFunction: item => {
      const payer = payersMap.get(item.data.payerId);
      if (!payer) {
        return <WSTableCell text="-" />;
      }
      const names = getPayerNames(payer);
      return (
        <WSTableCell
          text={names.getResolvedName()}
          secondaryText={names.getResolvedSecondaryName()}
          truncationOptions={{
            text: { allowTwoLines: true }
          }}
        />
      );
    }
  },
  {
    config: {
      header: {
        text: "Work log #"
      }
    },
    renderFunction: item => <WSTableCell text={item.data.workLogNumber} />
  },
  {
    config: {
      header: {
        text: "Amount"
      }
    },
    renderFunction: item => (
      <WSTableCell text={formatMoney(item.data.amount, "USD")} />
    )
  },
  {
    config: {
      header: {
        text: "Last modified"
      },
      onColumnSort: onSortByUpdatedAt,
      sortDirection: updatedAtDirection
    },
    renderFunction: item => (
      <WSTableCell text={toWSDateString(item.data.updatedAt, "timeframe")} />
    )
  },
  {
    config: {
      header: {
        text: "Status"
      }
    },
    renderFunction: item => {
      const invoice = invoicesMap?.get(item.data.invoiceId || "");

      const cellProps = getWorkLogPayeeStatusCellProps({
        workLog: item.data,
        invoice
      });

      return <WSTableCell {...cellProps} />;
    }
  }
];
